import styled from 'styled-components';
import { BaseButton } from 'components/ui/BaseButton';

export const PaymentContainer = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  background-color: #f8f9fa;
  border-radius: 10px;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  padding: 0;
`;

export const CardOptionLeftContainer = styled.div`
  display: flex;
`;

export const CardOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: stretch;
`;

export const RadioButton = styled.input`
  width: 20px;
  height: 20px;
`;

export const CardOption = styled.div<{ $isSelected: boolean; $management?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px;
  border-radius: 4px;
  border: 1px solid
    ${({ $isSelected, $management }) =>
      $management ? '#EAEBEF' : $isSelected ? '#003507' : '#E6EBF4'};
  background: #ffffff;
  cursor: pointer;
`;

export const CardNumber = styled.span`
  font-size: 16px;
  color: #0f0f0f;
  font-weight: 600;
  line-height: 24px;
`;

export const CardType = styled.span`
  font-size: 14px;
  color: #636a70;
  font-weight: 400;
  line-height: 16px;
`;

export const AddCardButton = styled(BaseButton)`
  // background-color: #3fc3b0 !important;
`;

export const DeleteIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  min-height: calc(100dvh - 300px);
`;

export const NoDataCardList = styled.div<{ $type?: string | null }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 20px 16px;
  // height: 154px;
  min-height: ${({ $type }) => ($type === 'membership' ? '154px' : 'calc(100dvh - 300px)')};
`;

export const NoDataText = styled.div`
  color: #b6b6b6;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  white-space: pre-line;
`;

export const NoDataButtonContainer = styled.div`
  width: 167px;
  display: flex;
  justify-content: center;
`;
